<template>
    <div class="container">
        <div v-if="!sent" class="col-lg-12 col-12 overflow-auto shadow">
            <div class="row"><h5 class="text-center head">{{ orderCreateDescription }}</h5></div>
            <div v-for="product in dataBuyStock" :key="product.subject" class="row">
                <div class="col-lg-7 col-6">{{ product.name }}</div>
                <div class="col-lg-2 col-2">{{ product.stock }}</div>
                <div class="col-lg-3 col-4">
                    <input v-model="basket[product.subject]" type="number" value="0" />
                </div>
            </div>
            <button @click="createOrder()">{{ createOrderButton }}</button>
        </div>
        <div v-if="sent" class="col-lg-12 col-12 overflow-auto text-center">
            <h5 class="text-center">{{ orderSent }}</h5>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

    export default{
        name:'CreateOrderPage',
        data(){
            return{
                basket: {},
                sent: false
            }
        },
        computed:{
            dataBuyStock(){
                return this.$store.state.dashboardData.buyStock ? this.$store.state.dashboardData.buyStock : 'Loading stock...';
            },
            orderCreateDescription(){
                return this.$store.state.languageData.languageArray ? this.$store.state.languageData.languageArray.order_create_description : 'Please write quantity to each wanted product';
            },
            createOrderButton(){
                return this.$store.state.languageData.languageArray ? this.$store.state.languageData.languageArray.order_create_button : 'Create order';
            },
            orderSent(){
                return this.$store.state.languageData.languageArray ? this.$store.state.languageData.languageArray.order_created : 'Order successfully created';
            }
        },
        methods:{
            createOrder(){
                const result = {
                    items:{}
                };
                Object.entries(this.basket).forEach(([subject, quantity]) => {
                    const isNumber = /^\d+$/.test(quantity);
                    if (quantity != '' && quantity != 0 && quantity != null && isNumber) {
                        result.items[subject] = parseInt(quantity, 10);  // Converting string to integer
                    }
                });
                result['username'] = this.$store.state.userCookies.username;
                result['token'] = this.$store.state.userCookies.token;

                axios.post(`${this.$store.state.serverData.backend}/api/order/create`,result)
                .then((response) => {
                    console.log(response);
                })
                .catch(() => {
                    this.$store.dispatch('setLogInError','serverside_error');
                });
            }
        }
    }
</script>

<style>

</style>